/**
 * @description This component is used to copy the dispatch link to the clipboard
 * @param {string} driverLink - The dispatch link to copy
 * @returns {React.ReactNode} - The component that allows to copy driver link
 */
import React, { FC, useState } from 'react';
import StringUtils from '../../utils/stringUtils';
import Typography from '@mui/material/Typography';
import { ReactComponent as LinkIcon } from '../../assets/icons/link.svg';

interface DriverLinkCopyProps {
  driverLink: string | null;
}

const DriverLinkCopy: FC<DriverLinkCopyProps> = ({ driverLink }) => {
  const [linkCopied, setLinkCopied] = useState(false);

  const handleCopy = async (): Promise<void> => {
    if (!driverLink) return;
    await StringUtils.copyToClipboard(driverLink);
    setLinkCopied(true);
    setTimeout(() => setLinkCopied(false), 2000);
  };

  if (!driverLink) return null;

  return (
    <span
      className="notify-driver__send-label"
      style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
    >
      <LinkIcon />
      <Typography
        component="span"
        sx={{ color: '#3A4DE9', fontSize: '14px', cursor: 'pointer' }}
        onClick={handleCopy}
      >
        {linkCopied ? 'Link copied!' : 'Copy dispatch link'}
      </Typography>
    </span>
  );
};

export default DriverLinkCopy;
